function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
$(document).ready(function(){
  //console.log("documenttt>>>",document.readyState);
  $('.quick-add__submit').attr('disabled',true)
})
$(window).on('load',function(){
  //console.log("documentuuu>>>",document.readyState);
  if(document.readyState == "complete"){
    $('.quick-add__submit').removeAttr('disabled')
  }
})
document.addEventListener('DOMContentLoaded', function () {

  var latestCarousel = document.querySelectorAll('.RQ_LatestCarouselWrpr.swiper.mySwiper');
  if(latestCarousel)
  latestCarousel.forEach(function(evt){
    var latestCarouselSlider = new Swiper(evt,{
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next_latest",
        prevEl: ".swiper-button-prev_latest"
      },
      pagination: {
        el: ".swiper-pagination_latest",
        clickable: true,
        dynamicBullets: true
      }
    })
  })

  var awardWiningPds = document.querySelectorAll('.awdWinSunscreenMN .RQ_AwrdWinPdsListMN.swiper.mySwiper');
  if (awardWiningPds) {
    awardWiningPds.forEach(function (evt) {
      var awardWiningPdsSlider = new Swiper(evt, {
        slidesPerView: 4,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true
        },
        breakpoints: {
          1025: {
            slidesPerView: 4
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          749: {
            slidesPerView: 2,
            spaceBetween: 18
          },
          0: {
            slidesPerView: 1.18,
            spaceBetween: 21
          }
        },
        on: {
          slideChange: function (swiper) {
            var direction = swiper.realIndex > swiper.previousIndex ? 'right' : 'left';
            var image_position = parseInt(swiper.previousIndex) + 1;

            // Use swiper.el to find the heading
            var section_heading = $(swiper.el).closest('.awdWinSunscreenMN').find('.RQ_AwrdWinPdsHeading').text().trim();

            dataLayer.push({
              'event': 'product_card_swipe',
              'page_section': section_heading,
              'swipe_direction': direction,
              'image_position': image_position
            });
          }
        }
      });
    });
  }


  var awardWiningPds = document.querySelectorAll('.clincBestsellersMN .RQ_AwrdWinPdsListMN.swiper.mySwiper');
  if (awardWiningPds)
    awardWiningPds.forEach(function (evt) {
      var awardWiningPdsSlider = new Swiper(evt, {
        slidesPerView: 3.29,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true
        },
        breakpoints: {
          1025: {
            slidesPerView: 3.29
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          749: {
            slidesPerView: 2
          },
          0: {
            slidesPerView: 1.25,
            spaceBetween: 16
          }
        },
        on: {
          slideChange: function (swiper, event) {
            var direction = swiper.realIndex > swiper.previousIndex ? 'right' : 'left';
            var image_position = parseInt(swiper.previousIndex) + 1
            var section_heading = $(swiper.el).closest('.RQ_AwrdWinPdsMN').find('.RQ_AwrdWinPdsHeading').text().trim();
            dataLayer.push({ 'event': 'product_card_swipe', 'page_section': section_heading, 'swipe_direction': direction, 'image_position': image_position });
          }
        }
      })
    })

  var customerOpinion = document.querySelectorAll('.RQ_CstmrOpionListMN.swiper.mySwiper');
  if (customerOpinion)

    var customerOpinionSlider = new Swiper(".RQ_CstmrOpionListMN.swiper.mySwiper", {
      slidesPerView: 3,
      spaceBetween: 44,
      orientationchange: true,
      resizeObserver: true,
      autoHeight: true,
      resizeReInit: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true
      },
      breakpoints: {
        991: { slidesPerView: 3, spaceBetween: 44, orientationchange: true, resizeObserver: true, resizeReInit: true, autoHeight: true },
        749: { slidesPerView: 2, spaceBetween: 28, orientationchange: true, resizeObserver: true, resizeReInit: true, autoHeight: true },
        0: { slidesPerView: 1, spaceBetween: 12, orientationchange: true, resizeObserver: true, resizeReInit: true, autoHeight: true }
      },
      on: {
        slideChange: function (swiper) {
          var direction = swiper.realIndex > swiper.previousIndex ? 'next' : 'prev';
          dataLayer.push({ 'event': 'testimonial_swipe', 'swipe_direction': direction });
        }
      }
    });

  var tabProducts = document.querySelectorAll('.RQ_SkinRgmTabCntItemMN.swiper.mySwiper');
  if (tabProducts)
    tabProducts.forEach(function (evt) {
      var tabPDsSlider = new Swiper(evt, {
        slidesPerView: 3.396,
        spaceBetween: 24,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          1024: {
            slidesPerView: 3.396
          },
          991: {
            slidesPerView: 3
          },
          749: {
            slidesPerView: 2
          },
          0: {
            slidesPerView: 1.18,
            spaceBetween: 16,
          }
        },
        on: {
          slideChange: function (swiper, event) {
            var direction = swiper.realIndex > swiper.previousIndex ? 'right' : 'left';
            var get_resigm_tab = $(".RQ_SkinRegimeTab.activeTab a").text();
            var image_position = parseInt(swiper.previousIndex) + 1
            var section_heading = $(swiper.el).closest('.RQ_SkinRegimeMN').find('.RQ_SkinRegimeHeading').text().trim();
            dataLayer.push({ 'event': 'product_card_swipe', 'page_section': section_heading, 'swipe_direction': direction, 'image_position': image_position, 'regime_step': get_resigm_tab });
          }
        }
      })
    })

  var tabGroupInit = document.querySelectorAll('[JSTabTargetHmInit]');
  if (tabGroupInit)
    tabGroupInit.forEach(function (evt) {
      evt.addEventListener('click', function (e) {
        e.preventDefault();
        var tabURL = this.getAttribute('href');
        this.parentNode.classList.add('activeTab');
        var node = this.parentNode.parentNode.firstChild;
        while (node) { if (node != this.parentNode && node.nodeType === Node.ELEMENT_NODE) node.classList.remove('activeTab'); node = node.nextElementSibling || node.nextSibling; }
        document.getElementById(tabURL).classList.add('activeProducts');
        var tabNode = document.getElementById(tabURL).parentNode.firstChild;
        while (tabNode) { if (tabNode != document.getElementById(tabURL) && tabNode.nodeType === Node.ELEMENT_NODE) tabNode.classList.remove('activeProducts'); tabNode = tabNode.nextElementSibling || tabNode.nextSibling; }
      })
    })

  var videoPopTarget = document.querySelector('.RQ_NewYearBnrWrpr');
  if (videoPopTarget)
    videoPopTarget.addEventListener('click', function (e) {
      // e.preventDefault();
      if (this.querySelector('.RQ_NewYearBnrMedia img').classList.contains('show_des')) {
        this.querySelector('.RQ_NewYearBnrVideo iframe.show_des').classList.add('popIframeActive');
      } else if (this.querySelector('.RQ_NewYearBnrMedia img').classList.contains('show_mb')) {
        this.querySelector('.RQ_NewYearBnrVideo iframe.show_mb').classList.add('popIframeActive');
      }
      document.body.classList.add('mainPopActive')
    })

  var videoPopOvrly = document.querySelector('.iframeOverlay');
  if (videoPopOvrly)
    videoPopOvrly.addEventListener('click', function (e) {
      document.body.classList.remove('mainPopActive');
      document.querySelector('.RQ_NewYearVideoMN iframe.show_des').classList.remove('popIframeActive');
      document.querySelector('.RQ_NewYearVideoMN iframe.show_mb').classList.remove('popIframeActive');
    })
  $(document).on("click", "li.menu_all_rpeat", function () {
    $(".menu_all_rpeat").removeClass("highlight_menu");
    $(this).addClass("highlight_menu");
  });
  $(document).on("click", ".back_button_main", function () {
    $("ul.menu-drawer__menu.has-submenu.list-menu.submenu-open details.menu-opening button.menu-drawer__close-button.link.link--text.focus-inset").trigger("click");
    $(".menu_all_rpeat").removeClass("highlight_menu");
  });
  var swiper = new Swiper(".shop_outer_data.swiper.mySwiper", {
    slidesPerView: 3,
    navigation: {
      nextEl: ".NextButtonSlideshowp",
      prevEl: ".PrevButtonSlideShowp"
    },
    grid: {
      rows: 3,
    },
    spaceBetween: 16,
    breakpoints: {
      749:
      {
        slidesPerView: 6,
        grid:
        {
          rows: 1,
        },
        spaceBetween: 16
      }
    }
  });
  if ($('#marquee-icon-horizontal').length > 0) { $('#marquee-icon-horizontal').marquee({ direction: 'horizontal', delay: 0, timing: 19, speed: 1, }); }
  var swiper = new Swiper(".RQ-newproduct-slider", {
    slidesPerView: 1.77,
    spaceBetween: 12,
    navigation: {
      nextEl: ".NextButtonSlideshowp",
      prevEl: ".PrevButtonSlideShowp"
    },
    pagination: {
      el: ".paginationSlideshowbannerp",
      clickable: true,
      dynamicBullets: true
    },
    breakpoints: {
      640:
      {
        slidesPerView: 1.77,
        spaceBetween: 13
      },
      768: {
        slidesPerView: 3.3,
        spaceBetween: 13
      },
      1024: {
        slidesPerView: 3.3,
        spaceBetween: 24
      }
    },
    on: {
      slideChange: function (swiper) {
        var direction = swiper.realIndex > swiper.previousIndex ? 'right' : 'left';
        var image_position = parseInt(swiper.previousIndex) + 1
        var section_heading = $(swiper.el).closest('.RQ-product-slideshow').find('.RQ-newlypro-heading').text().trim();
        dataLayer.push(
          { 'event': 'product_card_swipe', 'page_section': section_heading, 'swipe_direction': direction, 'image_position': image_position });
      }
    }
  });
  var swiper = new Swiper(".new-discounted_baner_slider", { slidesPerView: 1, spaceBetween: 16, autoplay: { delay: 3500, }, loop: true, pagination: { el: '.slider__pagination', clickable: true, }, breakpoints: { 768: { slidesPerView: 2, spaceBetween: 16, autoplay: { delay: 3500, }, loop: true, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', }, } } });
  $(document).on('click', '[jsplayvideo]', function (e) { e.preventDefault(); var indnmTab; $(this).parents('.VideoPLayExecutionWp').addClass('active'); if ($(window).width() > 749) { indnmTab = $(this).attr('videosrc'); } else { indnmTab = $(this).attr('mbvidoesrc'); } $('[jsvideoloadcontainer]').html('<div class="VideoInt"><video controls playsinline><source src="' + indnmTab + '" type="video/mp4"></video></div>'); });
  window.addEventListener('resize', function (event) {
    if ($(".VideoInt.show_des").children('video').length > 0) {
      if ($(window).width() > 769) {
        $(".VideoInt.show_mb").children('video').get(0).pause();
      } else {
        $(".VideoInt.show_des").children('video').get(0).pause();
      }
    }
  }, true);
  var swiper = new Swiper(".newly_launched_srach-products.swiper.mySwiper", {
    slidesPerView: 2.2, spaceBetween: 10, slidesPerGroupSkip: 1,
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', },
    breakpoints: { 640: { pagination: { el: '.slider__pagination', clickable: true, }, autoHeight: false, slidesPerGroupSkip: 1, slidesPerView: 4, spaceBetween: 16 }, 768: { pagination: { el: '.slider__pagination', clickable: true, }, autoHeight: false, slidesPerGroupSkip: 1, slidesPerView: 4, spaceBetween: 16 }, 1024: { pagination: { el: '.slider__pagination', clickable: true, }, autoHeight: false, slidesPerGroupSkip: 1, slidesPerView: 4, spaceBetween: 16 } },
    on: {
      slideChange: function (swiper) {
        var direction = swiper.realIndex > swiper.previousIndex ? 'left' : 'right';
        var image_position = parseInt(swiper.previousIndex) + 1
        dataLayer.push({ 'event': 'product_card_swipe', 'page_section': "Header", 'swipe_direction': direction, 'image_position': image_position });
      }
    }
  });


  var swiper = new Swiper(".menu_newly_launched_products.swiper.mySwiper", { slidesPerView: 2.22, spaceBetween: 17, slidesPerGroupSkip: 1, });
  $(document).on('click', '.IconClosedMenuDrw span', function (e) { e.preventDefault(); $('.menu-opening').children('.header__icon').trigger('click'); $('body').removeClass('overflow-hidden'); });
  setInterval(function () {
    if ($('.RqupsellItemslideshow').length > 0) {
      if ($('.RqupsellItemslideshow').hasClass('swiper-initialized')) { } else { var swiper = new Swiper(".RqupsellItemslideshow", { slidesPerView: 3.4, spaceBetween: 7, navigation: { nextEl: ".NextButtonSlideshowLine", prevEl: ".PrevButtonSlideShowLine" }, pagination: { el: ".swiper-pagination", type: "fraction" } }) }
    }
  }, 200);
  $(document).on('click', '[js-rewardopener]', function (e) {
    e.preventDefault();
    $(this).parents('.GiftRewardsWrapper').toggleClass('active').siblings().removeClass('active');
    if ($(this).parents(".GiftRewardsWrapper.UpsellWrapperCard").hasClass("active")) {
      setCookie('accordion_close', 'no', 1);
    } else {
      setCookie('accordion_close', 'yes', 1);
    }

  });
});
$(window).on("load resize", function () {
  if ($(window).width() < 749) {
    let height = $(".shop_concern_images_rpeater_wrapper a .shop_concern_image_content_wrapp").height() * 2 + 20;
    $(".shop_outer_data").css("height", height + "px");
  } else {
    $(".shop_outer_data").css("height", "unset");
  }
});


$(window).on("load", function () {
  var getcontent = getCookie('accordion_close');
  if (getcontent == 'yes') {
    $(".drawer__footer .GiftRewardsWrapper.UpsellWrapperCard").removeClass("active");
  } else {
    $(".drawer__footer .GiftRewardsWrapper.UpsellWrapperCard").addClass("active");
  }
});
$(document).on("change", ".input_label_wrapper input", function () {
  var variant_price = $(this).attr("var-price");
  $(this).parents(".card-information").find(".price__regular .price-item--regular").html(variant_price);
});
$(document).on("change", ".new-colection-variants input", function () {
  var variant_id = $(this).attr("var-id");
  var variant_price = $(this).attr("var-price");
  var variant_compareprice = $(this).attr("var-com-price");
  var variant_saleprice = $(this).attr("var-discount");
  var variant_quantity = $(this).attr("var-quantity");
  var variant_policy = $(this).attr("var-policy");
  $(this).parents(".card__content").find(".collProFrm input[name=id]").val(variant_id);
  $(this).parents(".card__content").find(".price__sale span.price-item.price-item--sale.price-item--last").html(variant_price);
  $(this).parents(".card__content").find(".price__sale s.price-item.price-item--regular").html(variant_compareprice);
  $(this).parents(".card__content").find(".PriceWithpercentage span.priceOffer").html(variant_saleprice);

  if (variant_quantity == 0 && variant_policy == 'deny') {
    $(this).parents(".card__content").find("span.add_to_cart_text").addClass("hidden");
    $(this).parents(".card__content").find("span.sold-out-message").removeClass("hidden");
    $(this).parents(".card__content").find(".quick-add__submit").attr("aria-disabled", true);
  } else {
    $(this).parents(".card__content").find("span.add_to_cart_text").removeClass("hidden");
    $(this).parents(".card__content").find("span.sold-out-message").addClass("hidden");
    $(this).parents(".card__content").find(".quick-add__submit").removeAttr("aria-disabled");
  }
});
$(document).on("change", ".new-colection-variants .INputMnradioBtn input", function () {
  var variant_image = $(this).attr("var-image");
  if ($(window).width() < 990) {
    $(this).parents(".CollProGridItem").find(".fisst_new_image").attr("src", variant_image);
    $(this).parents(".CollProGridItem").find(".fisst_new_image").attr("srcset", variant_image);
  } else {
    $(this).parents(".CollProGridItem").find("img.new-tem-second-image.motion-reduce").attr("src", variant_image);
    $(this).parents(".CollProGridItem").find("img.new-tem-second-image.motion-reduce").attr("srcset", variant_image);
  }
});
$(".new-colection-variants .allvarinat_wrapper input").change(function () {
  var var_price = $(this).attr("var-price");
  var var_com_price = $(this).attr("var-com-price");
  var var_value_name = $(this).val();
  var product_title = $(this).parents(".card__information").find(".card__heading a").text();
  var trimed_pro_title = $.trim(product_title);
  if (typeof var_com_price !== 'undefined') {
    $(this).parents(".card-information").find("span.price-item.price-item--sale.price-item--last").html(var_price);

    $(this).parents(".card-information").find("s.price-item.price-item--regular").html(var_com_price);
    $(this).parents(".card-information").find("s.price-item.price-item--regular").show();
    $(this).parents(".card-information").find(".PriceWithpercentage").show();
  } else {
    $(this).parents(".card-information").find("span.price-item.price-item--sale.price-item--last").html(var_price);

    $(this).parents(".card-information").find("s.price-item.price-item--regular").hide();
    $(this).parents(".card-information").find(".PriceWithpercentage").hide();

  }
  dataLayer.push({ 'event': 'product_variant_click', 'click_text': var_value_name, 'product_title': trimed_pro_title });
});


$(document).on("click", "a.mobile_header_search", function (e) {
  e.preventDefault();
  $("body").addClass("SearchBarFocused");
  $(".MobileSearchIconWrapper .mobile_new_search_inner").show();
  $("header.header").addClass("search-bar-active");
  $("body").addClass("desktopSearchBarFocused");
  setTimeout(function () {
    $(".search__input.field__input").focus();
  }, 1200);
});
$(document).mouseup(function (e) {
  if ($(e.target).closest("details-modal#header_mobile_search").length
    === 0) {
    $("header.header").removeClass("search-bar-active");
    $("body").removeClass("desktopSearchBarFocused");
  }
});
$(document).on("click", "button.search-modal__close-button", function (e) {
  $("body").removeClass("SearchBarFocused");
  $(".MobileSearchIconWrapper .mobile_new_search_inner").hide();
});
$(document).on("keyup", "input#Search-In-Modal", function (e) {
  var valuelenght = $(this).val().length;
  if (valuelenght > 0) {
    $(".main_mob_popular_search").hide();
    $(".recent-searched-products").hide();
    $(".GetHtmlOFSearch .newly_pro_heading-wrapp").show();
    $("div#predictive-search-results").show();

  } else {
    $(".main_mob_popular_search").show();
    $(".recent-searched-products").show();
    $("div#predictive-search-results").hide();
    $(".GetHtmlOFSearch .newly_pro_heading-wrapp").hide();
  }

});

$(document).on("keyup", "input#Search-In-Modal-1", function (e) {
  var valuelenght = $(this).val().length;
  if (valuelenght > 0) {
    $(".main_desktop_popular_search").hide();
    $(".main_desktop_popular_search .recent-searched-products").hide();
    $(".MainHeaderNavigationCombine .recent-searched-products").hide();
    $(".MainHeaderNavigationCombine .newly_pro_heading-wrapp").hide();
    $("predictive-search.search-modal__form").attr("open", "open");
  } else {
    $(".main_desktop_popular_search").show();
    $(".main_desktop_popular_search .recent-searched-products").show();
    $(".MainHeaderNavigationCombine .recent-searched-products").show();
    $(".MainHeaderNavigationCombine .newly_pro_heading-wrapp").show();
    $("predictive-search.search-modal__form").removeAttr("open", "open");
  }

});



$(document).on("click", ".gift_boxes-plus_icon", function () {
  $("body").addClass("gift_popup_active");
  $(".custom_main_gift-popup").addClass("gift_mainpopup_active");
});
$(document).on("click", ".custom-popup-gift_box_inner .gift-popup-cross", function () {
  $("body").removeClass("gift_popup_active");
  $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");
});
// localStorage.removeItem("giftBoxVarid");
var boxgiftid = localStorage.getItem('giftBoxVarid');
if (boxgiftid) {
  $(".gift_popup-addtocart button").prop("disabled", true);
  //$(".gift_popup-addtocart").remove();
}

$(document).on("click", ".custom_main_gift-popup .gift_popup-addtocart button", function () {
  var $button = $(this); // Store reference to the clicked button 
  var productid = $button.parents(".gift_popup-addtocart").attr("data-varid");
  localStorage.setItem("giftBoxVarid", productid);
  //////////// if product is already added //////////////////
  // Step 1: Fetch current cart data
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      // Step 2: Check if variant_id already exists in the cart
      var isAlreadyInCart = cart.items.some(item => item.variant_id == productid);

      if (isAlreadyInCart) {
        console.log(`Variant ID ${productid} is already in the cart. Skipping add.`);
        
        // Optionally display a message or prevent further actions
        //alert("This item is already in your cart.");
        return;  // Stop execution if variant is already in the cart
      }
    }
  });
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: productid,
      quantity: 1,
    },
    dataType: 'json',
    success: function (productid2) {
      console.log('productid2---->>>',productid2);
      jQuery.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function (cart22) {

          if ($(".UpsellWrapperCard").hasClass("active")) {
          } else {
            setTimeout(function () {
              $(".UpsellWrapperCard").removeClass("active");
            }, 800);

          }
          fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
            const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
            const bubble = document.querySelector('#cart-icon-bubble');
            bubble.innerHTML = bubbleHTML;


          })
          fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
            const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
            const drawer = document.querySelector('cart-drawer');
            drawer.innerHTML = newHTML;
            var newboxid = localStorage.getItem('giftBoxVarid');
            // if (newboxid) {
            //   Correct way to disable the button
            //   $(".gift_popup-addtocart button").prop("disabled", true);
            //   Remove the entire div if needed
            //   $(".gift_popup-addtocart").remove();
            // }

          });

          $(".RQCartDRawerExecutionmWp ").removeClass("is-empty");
          $(".RQCartDRawerExecutionmWp ").addClass("active");
          $("body").removeClass("gift_popup_active");
          $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");

          setTimeout(function () {
            Smile.ready().then(smileInstance => {
              $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
            }).catch(err => {
              // An error has occurred will initializing smile.
            });
            if (document.querySelectorAll('.new_custom_drawer_products').length > 0) {
              function FounderCookie(cookieName) {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                  const cookie = cookies[i].trim();
                  if (cookie.startsWith(cookieName + '=')) {
                    return true;
                  }
                }
                return false;
              }

              function startTimer(duration, display) {
                console.log(123456789);
                var timer = duration, minutes, seconds;
                setInterval(function () {

                  minutes = parseInt(timer / 60, 10)
                  seconds = parseInt(timer % 60, 10);
                  // minutes = minutes < 10 ? "0" + minutes : minutes;
                  // seconds = seconds < 10 ? "0" + seconds : seconds;

                  var minutes_fst = minutes.toString().split("").map(Number)[0];
                  var minutes_scd = minutes.toString().split("").map(Number)[1];

                  var seconds_fst = seconds.toString().split("").map(Number)[0];
                  var seconds_scd = seconds.toString().split("").map(Number)[1];

                  if (typeof minutes_scd !== 'undefined') {
                    display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
                  } else {
                    display.querySelector('#timer-hours').innerHTML = `<span>0</span><span>${minutes_fst}</span>`;
                  }

                  if (typeof seconds_scd !== 'undefined') {
                    display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
                  } else {
                    display.querySelector('#timer-minutes').innerHTML = `<span>0</span><span>${seconds_fst}</span>`;
                  }


                  if (FounderCookie('offerInvalid')) { } else {
                    if (--timer < 0) {
                      const expirationDate = new Date();
                      expirationDate.setDate(expirationDate.getDate() + 7);
                      document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                    }
                  }

                  if (FounderCookie('offerInvalid')) {
                    if (document.querySelector('.drawer_timer_outer-wrapp')) {
                      document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                    }
                    if (document.querySelector('.new_custom_drawer_products')) {
                      document.querySelector('.new_custom_drawer_products').style.display = 'none';
                    }
                    window.localStorage.removeItem("seconds")
                    window.localStorage.removeItem("minutes")
                  } else {
                    if (document.querySelector('.drawer_timer_outer-wrapp')) {
                      document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                    }
                    if (document.querySelector('.new_custom_drawer_products')) {
                      document.querySelector('.new_custom_drawer_products').style.display = 'block';
                    }
                    window.localStorage.setItem("seconds", seconds)
                    window.localStorage.setItem("minutes", minutes)
                  }



                }, 1000);
              }

              var sec = parseInt(window.localStorage.getItem("seconds"));
              var min = parseInt(window.localStorage.getItem("minutes"));

              if (FounderCookie('offerInvalid')) {
                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                  document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                }
                if (document.querySelector('.new_custom_drawer_products')) {
                  document.querySelector('.new_custom_drawer_products').style.display = 'none';
                }
                window.localStorage.removeItem("seconds")
                window.localStorage.removeItem("minutes")
              } else {
                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                  document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                }
                if (document.querySelector('.new_custom_drawer_products')) {
                  document.querySelector('.new_custom_drawer_products').style.display = 'block';
                }
              }

              if (parseInt(min * sec)) {
                var fiveMinutes = (parseInt(min * 60) + sec);
              } else {
                var fiveMinutes = 60 * 30;
              }

              var display = document.querySelector('#timer-box');
              if (parseInt(min) == 0) {
                console.log(1234567);
                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                  document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                }
                if (document.querySelector('.new_custom_drawer_products')) {
                  document.querySelector('.new_custom_drawer_products').style.display = 'none';
                }
                window.localStorage.removeItem("seconds")
                window.localStorage.removeItem("minutes")
                const expirationDate = new Date();
                expirationDate.setDate(expirationDate.getDate() + 7);
                document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
              } else {
                startTimer(fiveMinutes, display);
              }

            } else {
              document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
            }
          }, 800);
        },
      });
    },
  });
  
});


$(document).on("click", ".tick_icon_added-text", function () {
  localStorage.removeItem("giftBoxVarid");
  var Obj = $(this).attr("data-varid");

  // alert(Obj);
  let updates = {
    [Obj]: 0
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
    .then(response => {
      return response.json();
    }).then(results => {
      $.ajax({
        type: 'GET',
        url: '/',
        dataType: 'html',
        success: function (html_get) {
          if ($(".UpsellWrapperCard").hasClass("active")) {
          } else {
            setTimeout(function () {
              $(".UpsellWrapperCard").removeClass("active");
            }, 800);

          }
          fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
            const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
            const bubble = document.querySelector('#cart-icon-bubble');
            bubble.innerHTML = bubbleHTML;
          })
          fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
            const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
            const drawer = document.querySelector('cart-drawer');
            drawer.innerHTML = newHTML;
          });
          $(".RQCartDRawerExecutionmWp ").removeClass("is-empty");
          $(".RQCartDRawerExecutionmWp ").addClass("active");
          $("body").removeClass("gift_popup_active");
          $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");
          setTimeout(function () {
            Smile.ready().then(smileInstance => {
              $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
            }).catch(err => {
              // An error has occurred will initializing smile.
            });
          }, 800);
        },
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
});
var swiper = new Swiper(".gift_popup_pro_slider ", { slidesPerView: 1, spaceBetween: 5, pagination: { el: ".swiper-pagination_popup", clickable: true, dynamicBullets: true }, });
